import React, { useEffect, useState } from 'react'

import "common/css/master.css";


const TeacherAllocationTable = (props) => {
    const { lstTeacherAllocation, teacherAllocationId, setTeacherAllocationId, editTeacherAllocation, deleteTeacherAllocation } = props;

    const [lstTeacherAllocationFiltered, setLstTeacherAllocationFiltered] = useState([]);
    const [selTeacherAllocationId, setSelTeacherAllocationId] = useState(0);
    const [flgOnlyAvailableChecked, setFlgOnlyAvailableChecked] = useState(false);
    const [teacherFiltered, setTeacherFiltered] = useState("");

    useEffect(() => {
        // console.log("useEffect in TeacherAllocationTable component called, lstTeacherAllocation", lstTeacherAllocation);
        setTeacherFiltered("");
        setFlgOnlyAvailableChecked(false);
        setLstTeacherAllocationFiltered(lstTeacherAllocation);
    }, [lstTeacherAllocation]);

    useEffect(() => {
        // console.log("useEffect in TeacherAllocationTable component called teacherAllocationId", teacherAllocationId);
        setSelTeacherAllocationId(teacherAllocationId);
    }, [teacherAllocationId]);

    const handleFilterAvailable = (check) => {
        setFlgOnlyAvailableChecked(check);
        filterTeacherTable(teacherFiltered, check);
    }

    const handleFilterTeacher = (fTeacher) => {
        setTeacherFiltered(fTeacher);
        filterTeacherTable(fTeacher, flgOnlyAvailableChecked);
    }

    const colgrp = <colgroup>
        <col width="80"></col>
        <col width="25"></col>
        <col width="35"></col>
        <col width="35"></col>
        <col width="35"></col>
        <col width="35"></col>
        <col width="40"></col>
    </colgroup>

    function binaryToDays(binaryString) {
        // console.log("Method called: binaryToDays");
        // console.log("Parameters passed:", { binaryString });

        const daysOfWeek = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
        let result = '';

        for (let i = 0; i < binaryString.length; i++) {
            if (binaryString[i] === '1') {
                result += daysOfWeek[i];
            } else {
                result += "-"
            }
        }

        // console.log("Value to be returned:", result);
        return result;
    }


    const filterTeacherTable = async (fTeacher, fAvailable) => {
        // console.log("filterTeacherTable called");
        // console.log("lstTeacherAllocation:", lstTeacherAllocation);
        // console.log("fAvailable:", fAvailable);

        let filteredTeacherTable = [];
        filteredTeacherTable = lstTeacherAllocation.filter(teacher =>
            teacher.tch.toLowerCase().includes(fTeacher.toLowerCase())
        );

        if (fAvailable) {
            filteredTeacherTable = filteredTeacherTable.filter(teacher =>
                teacher.available
            );
        }

        await setLstTeacherAllocationFiltered(filteredTeacherTable);
    }

    return (
        <div >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr>
                            <th >
                                <input
                                    type="text" className="form-control inp-search"
                                    value={teacherFiltered}
                                    onChange={(e) => handleFilterTeacher(e.target.value)}
                                    name="teacher name"
                                    placeholder="Teacher" />
                            </th>
                            <th  >
                                <div className='col-sm-12 padding-remove '>
                                    Available
                                </div>
                                <div className='col-sm-1 col-centered padding-remove '>
                                    <input
                                        autoComplete="off"
                                        id="mon"
                                        type="checkbox"
                                        className="form-control "
                                        checked={flgOnlyAvailableChecked}
                                        onChange={(e) => handleFilterAvailable(e.target.checked)}
                                    />
                                </div>
                            </th>
                            <th >
                                Weekly Periods
                            </th>
                            <th >
                                Days Off
                            </th>
                            <th >
                                Periods Off
                            </th>
                            <th >
                                Allocation Periods
                            </th>
                            <th >
                                Action
                            </th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "60vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="diaryMonthlyTeacherAllocationTable" >
                            {lstTeacherAllocationFiltered &&
                                lstTeacherAllocationFiltered.map((teacherAllocation, i) => (
                                    <tr key={teacherAllocation.teacherAllocationId}
                                        onClick={() => setTeacherAllocationId(teacherAllocation.teacherAllocationId)}
                                        className={teacherAllocation.tchId === selTeacherAllocationId ? "selected" : ''}>
                                        <td className="text-left">{teacherAllocation.tch}</td>
                                        <td className="text-center">{teacherAllocation.available ?
                                            <span
                                                style={{ color: "green" }}
                                                className='glyphicon glyphicon-ok'
                                            ></span>
                                            :
                                            <span
                                                className='glyphicon glyphicon-remove'
                                            ></span>
                                        }</td>
                                        <td className="text-center">{teacherAllocation.weeklyPeriods}</td>
                                        <td className="text-center">{binaryToDays(teacherAllocation.daysOff)}</td>
                                        <td className="text-center">{teacherAllocation.periodsOff}</td>
                                        <td className="text-center">{teacherAllocation.periodsAllocated + " / " + teacherAllocation.weeklyPeriods}</td>
                                        <td className="text-center" >
                                            <span
                                                onClick={() => editTeacherAllocation(teacherAllocation)}
                                                title="Edit Teacher Allocation Details"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                            >
                                                Edit
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default TeacherAllocationTable;